export default "__VITE_ASSET__fd8e41c4__"